var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngry2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "angry",
    d: "M25,8A25,25,0,1,0,50,33,25,25,0,0,0,25,8ZM13.71,31.387a3.193,3.193,0,0,1,1.058-2.359l-3.125-.937a1.611,1.611,0,1,1,.927-3.085l8.065,2.419a1.612,1.612,0,0,1-.464,3.155c-.05,0-.111-.02-.171-.02a3.259,3.259,0,0,1,.171.827,3.231,3.231,0,0,1-6.462,0ZM30.645,46.931a7.584,7.584,0,0,0-11.3,0,1.614,1.614,0,0,1-2.48-2.067,10.568,10.568,0,0,1,16.25,0A1.61,1.61,0,0,1,30.645,46.931Zm7.722-18.841-3.125.938a3.217,3.217,0,1,1-5.393,2.359,2.807,2.807,0,0,1,.171-.827.993.993,0,0,1-.171.02,1.612,1.612,0,0,1-.464-3.155l8.065-2.419a1.609,1.609,0,1,1,.917,3.085Z",
    transform: "translate(0 -8)",
    fill: "#ff5962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry2);
export default __webpack_public_path__ + "static/media/angry-2.a1f7d174ca3d47ef847f5ec4ecb210fa.svg";
export { ForwardRef as ReactComponent };